import { useGlobalContext } from "context/GlobalContext";
import React from "react";
import "./OrderClientDetailsStyle.css";
import { useLocation } from "react-router-dom";
import { ReactComponent as InfoIcon } from "assets/icons/Bredcrum_Icon/infoIcon.svg";

const OrderClientDetailsComp = () => {
  const { clientDetails } = useGlobalContext();
  const location = useLocation();

  return (
    <div>
      <div className="chip-container" style={{ justifyContent: location?.pathname === "/CartOrder" ? "flex-start" : "" }}>
        {clientDetails &&
          clientDetails.map((chip, item) => {
            const { icon, label, value, infoAction } = chip;
            return (
              <div key={item} className="chip-section">
                <span className="chip-icon">{icon}</span>
                <p className="chip-name">{`${label} :`}</p>
                <p className="chip-value">{value}</p>
                {infoAction && (
                  <span
                    onClick={infoAction}
                    style={{
                      cursor: "pointer",
                      marginLeft: "5px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <InfoIcon />
                  </span>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default OrderClientDetailsComp;
